import React from 'react';
import { useTranslation } from 'react-i18next';

interface NotificationDotProps {
  visible: boolean;
  pulse?: boolean;
  ariaLabel?: string;
  /** Callback when dot starts fading out */
  onFadeOut?: () => void;
}

/**
 * Small red notification indicator dot for sidebar navigation items.
 * Positioned absolutely, visible in both light and dark modes.
 * Includes fade-out animation when hiding.
 */
export const NotificationDot: React.FC<NotificationDotProps> = ({
  visible,
  pulse = false,
  ariaLabel,
}) => {
  const { t } = useTranslation();
  const label = ariaLabel ?? t('layout.badge.newContentAvailable');
  // Render hidden instead of null to allow CSS animation
  return (
    <span
      className={`
        absolute -top-1 -right-1
        w-2 h-2
        bg-red-500
        rounded-full
        transition-opacity duration-300 ease-out
        ${visible ? 'opacity-100' : 'opacity-0'}
        ${pulse ? 'animate-pulse' : ''}
      `}
      aria-label={label}
      role="status"
      aria-hidden={!visible}
    />
  );
};

export default NotificationDot;